import { useRef } from "react";
import { Printer } from "react-feather";
import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { Card, CardHeader } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { CreatedByMeHeading, Href, Print } from "../../../../utils/Constant";
import CreatedByMe from "./CreatedByMe";

const ListOfTask = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef,
  });
  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <H4 className="mb-0">{CreatedByMeHeading}</H4>
        <Link to={Href} onClick={() => handlePrint()}>
          <Printer className="me-2" />
          {Print}
        </Link>
      </CardHeader>
      <CreatedByMe ref={contentRef} />
    </Card>
  );
};

export default ListOfTask;
